import Grid from '@mui/material/Grid';
import ShippingDetailDatagridComponent from './_sections/_datagrid/ShippingDetailDatagridComponent';
import ShippingDetailFooterComponent from './_sections/_footer/ShippingDetailFooterComponent';
import ShippingDetailHeaderComponent from './_sections/_header/ShippingDetailHeaderComponent';
import FiltersComponentDetails from './_sections/filters/FiltersComponentDetails';

const ShippingDetailComponent = () => {
  return (
    <Grid container>
      <ShippingDetailHeaderComponent />
      <FiltersComponentDetails />
      <ShippingDetailDatagridComponent />
      <ShippingDetailFooterComponent />
    </Grid>
  );
};

export default ShippingDetailComponent;
